import styled from "styled-components";
import { BiChevronUp } from "react-icons/bi";

export const InfoContainer = styled.div`
  background: #8f8073;
  position: relative;
  z-index: 1;
  offset: -80px;
`;

export const InfoContent = styled.div`
  display: grid;
  width: 100%;
  height: auto;
  min-height: 800px;
  padding: 0 30px;
  grid-auto-columns: minmax(auto, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 20px;

  grid-template-areas: ${({ imgStart }) =>
    imgStart ? `'col1 col2' 'col3 col4'` : `'col1 col2' 'col4 col3'`};

  @media screen and (max-width: 768px) {
    grid-template-areas: ${({ imgStart }) =>
      imgStart
        ? `'col1' 'col2' 'col3' 'col4'`
        : `'col1 col1' 'col2 col2' 'col3 col3' 'col4 col4'`};
  }
`;

export const InfoH1 = styled.h1`
  color: #fff;
  font-size: 48px;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 40px;
  }

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const InfoH3 = styled.h3`
  padding: 10px;
  color: #fff;
  font-size: 24px;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

export const InfoP1 = styled.p`
  padding: 20px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  grid-area: col1;
`;

export const InfoP2 = styled.p`
  padding: 20px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  grid-area: col2;
`;

export const InfoP3 = styled.p`
  padding: 20px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  grid-area: col4;
`;

export const InfoP4 = styled.p`
  padding: 20px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  grid-area: col3;
`;

export const InfoImg = styled.img`
  width: 300px;
  height: 300px;
  background: #ffffff;

  @media screen and (max-width: 768px) {
    width: 200px;
    height: 200px;
  }

  @media screen and (max-width: 480px) {
    width: 100px;
    height: 100px;
  }
`;

export const InfoBtnWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const UpArrow = styled(BiChevronUp)`
  margin-left: 8px;
  font-size: 20px;
`;
